export class ActivityRequest {
  page: number = 1;
  perPage: number = 30;
  advisorKeycloakIds: string[] = [];
  eventTypes: string[] = ['ALL'];
  saveRequest: boolean = false;
}
